import log from "../log";

/**
 * Blends two hex colors together.
 */
const combineHexColor = ({
	hexBase,
	hexManipulate,
	weight = 1,
}: {
	hexBase: string;
	hexManipulate: string;
	/**
	 * Number between 0 and 1 that determines the weight of the second color in the blend.
	 */
	weight?: number;
}) => {
	try {
		hexBase = hexBase.trim().toUpperCase();
		hexManipulate = hexManipulate.trim().toUpperCase();
		if (hexBase.length !== 7 || hexManipulate.length !== 7) {
			throw new Error("Invalid hex color format");
		}

		const baseR = parseInt(hexBase.slice(1, 3), 16);
		const baseG = parseInt(hexBase.slice(3, 5), 16);
		const baseB = parseInt(hexBase.slice(5, 7), 16);

		const manipulateR = parseInt(hexManipulate.slice(1, 3), 16);
		const manipulateG = parseInt(hexManipulate.slice(3, 5), 16);
		const manipulateB = parseInt(hexManipulate.slice(5, 7), 16);

		const blendedR = Math.round(baseR + (manipulateR - baseR) * weight)
			.toString(16)
			.toUpperCase();
		const blendedG = Math.round(baseG + (manipulateG - baseG) * weight)
			.toString(16)
			.toUpperCase();
		const blendedB = Math.round(baseB + (manipulateB - baseB) * weight)
			.toString(16)
			.toUpperCase();

		const blendedHex =
			"#" +
			(blendedR.length === 1 ? "0" + blendedR : blendedR) +
			(blendedG.length === 1 ? "0" + blendedG : blendedG) +
			(blendedB.length === 1 ? "0" + blendedB : blendedB);
		return blendedHex;
	} catch (err) {
		log.error({ err }, "Error in combineHexColor");
		return hexBase;
	}
};
export default combineHexColor;
